var TEMPLATE_URL = require('./chooser.small.html');
angular.module('ikeweb.locale').directive('localeChooserSmall', [

    function() {
        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            controller: 'LocaleChooserController',
            controllerAs: 'ctrl',
            scope: {},
            link: function($scope) {
                $scope.showDropdown = false;

                $scope.toggleDropdown = function($evt) {
                    $evt.stopPropagation();
                    $scope.showDropdown = !$scope.showDropdown;

                    if ($scope.showDropdown) {
                        $('body').on('click.dropdown', function() {
                            $scope.$apply(function() {
                                $scope.showDropdown = false;
                                $('body').off('click.dropdown');
                            });
                        });
                    }
                };
            }
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/locale/chooser-small/chooser.small.directive.js
// module id = 507
// module chunks = 0